import React from 'react';

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Action
import * as helpAction from '../action/helpAction';



class Comp extends React.Component {

	render() {

    let styleOuter = {
      position:'relative',
      display:'inline-block',
      margin:'3px',
      padding:'5px 10px',
      background:'#DDD',
      textAlign:'left',
      zIndex:'10',
      color:'#666',
			borderRadius:'12px',
			maxWidth:'400px'
    }


    let breach = this.props.breach;

    if (breach) {
      return (
        <div style={styleOuter}>
          <span
            className='red_icon'
            onClick={ () => this.props.helpOpen('id',375) }
          >
            違反カード
          </span>
          { breach }
        </div>
  		)
    }
    else {
      return null;
    }
	}
}


const mapStateToProps = (state) => {
	return {
    my: state.my,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
    ...helpAction,
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
